import { ChangeDetectionStrategy, Component, output } from '@angular/core';

export type MonitoringFlow = 'ai' | 'wizard';

@Component({
  selector: 'cmb-flow-chooser',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './flow-chooser-monitoring.html',
  styleUrl: './flow-chooser-monitoring.scss',
})
export class FlowChooserMonitoring {
  readonly choose = output<MonitoringFlow>();
}
